import Literal from 'components/Literal'; // FIXME Please use getLiteral here

export default function ({ providers }) {
    let content =
        providers.length > 0 ? (
            providers
        ) : (
            <Literal className="no-providers" literal="error_nointegatrions_available" />
        );
    return (
        <div className="integrations">
            <div className="title-integrations">
                <Literal literal="title_integrations" />
            </div>
            <div className="description-integrations">
                <Literal literal="helptext_integrations" />
            </div>
            {content}
        </div>
    );
}
